/** Finanse → Windykacja (etap X1). */
export const collPl = {
  nav: 'Windykacja',
  title: 'Windykacja',
  subtitle: 'Należności, lista wstydu, Top 40 i sprawy w kancelarii',
  subtitleAsOf: 'Stan należności na {date} · dane z InsERT i NEXOPS',
  demo: 'dane przykładowe',
  tabs: { receivables: 'Należności', shame: 'Lista wstydu', top40: 'Top 40 do wysyłki', cases: 'Sprawy w kancelarii' },
  kpi: {
    open: 'Należności',
    openHint: '{count} faktur przeterminowanych',
    overdue: 'Przeterminowane',
    overdueHint: '{count} dłużników',
    over90: 'Ponad 90 dni',
    over90Hint: '{value} przeterminowanych',
    top40: 'Top 40 razem',
    top40Hint: '{value} wszystkich przeterminowanych',
  },
  buckets: { all: 'Wszystkie', d0_30: '0–30 dni', d31_60: '31–60 dni', d61_90: '61–90 dni', d90plus: 'Ponad 90 dni' },
  bucketsLabel: 'Przedział przeterminowania',
  search: 'Szukaj klienta lub NIP…',
  region: 'Region',
  allRegions: 'Wszystkie regiony',
  noRegion: 'bez regionu',
  noOwner: 'bez opiekuna',
  groups: { byOwner: 'Wg handlowca', byRegion: 'Wg regionu', debtors: 'dłużn.', overdue: 'Przeterm.', over90: '> 90 dni' },
  table: {
    customer: 'Klient',
    owner: 'Handlowiec',
    open: 'Należności',
    overdue: 'Przeterminowane',
    days: 'Dni',
    coefficient: 'Współczynnik',
    stage: 'Etap',
    rank: 'Lp.',
    daysN: '{count} dni',
    avgDays: 'śr. {count} dni',
    zeroTurnover: 'obrót 0',
    financed: 'factoring',
    turnover: 'Obrót 3 mies.',
    oldestDue: 'Najstarszy termin',
    alerts: 'Alerty',
    share: 'Udział',
    empty: 'Brak dłużników dla wybranych filtrów',
    count: '{count} dłużników',
    open90: 'Otwórz ścieżkę windykacji',
  },
  stage: {
    NONE: 'Brak działań',
    EMAIL: 'E-monit',
    PHONE: 'Telefon',
    URGE1: 'Ponaglenie 1',
    URGE2: 'Ponaglenie 2',
    URGE3: 'Ponaglenie 3',
    DEMAND: 'Wezwanie do zapłaty',
    FINAL_DEMAND: 'Ostateczne wezwanie',
    AGENCY: 'Kancelaria',
    COURT: 'Sąd',
    INTEREST_NOTE: 'Nota odsetkowa',
    OTHER: 'Inne działanie',
  },
  alert: {
    OVER_90: 'ponad 90 dni',
    OVER_LIMIT: 'limit przekroczony',
    LEGAL: 'w kancelarii / sądzie',
    ZERO_TURNOVER: 'obrót 0',
    FINANCED: 'factoring',
    NO_ACTION: 'brak działań',
  },
  shame: {
    title: 'Lista wstydu',
    hint: 'Współczynnik = przeterminowane × średnia liczba dni spóźnienia / obrót netto z 3 miesięcy (D14). Im wyżej, tym gorzej.',
    zeroTitle: 'Obrót 0 — współczynnik nieokreślony',
    zeroHint: 'Dłużnicy bez sprzedaży w ostatnich 3 miesiącach: dług rośnie, a klient już nie kupuje.',
  },
  top40: {
    title: 'Top 40 dłużników',
    hint: 'Zestawienie dla głównej księgowej — 40 największych przeterminowanych sald z terminem, sumą i alertami.',
    share: '{value} wszystkich przeterminowanych',
    avgDays: 'Śr. dni spóźnienia',
    withLegal: 'W kancelarii / sądzie',
    withoutAction: 'Bez działań',
    over90: 'Ponad 90 dni',
    sendNow: 'Wyślij teraz',
    sent: 'Wysłano Top 40 do {count} odbiorców',
    sendFailed: 'Nie udało się wysłać: {count}',
    schedule: 'Wysyłka cykliczna: {value}',
    scheduleOff: 'Wysyłka cykliczna wyłączona (Ustawienia → Windykacja)',
  },
  export: { xlsx: 'XLS', pdf: 'PDF', preparing: 'Przygotowuję plik…', done: 'Pobrano {name}', failed: 'Nie udało się przygotować pliku' },
  drawer: {
    path: 'Ścieżka windykacji',
    pathHint: 'Bieżący epizod — od terminu najstarszej przeterminowanej faktury',
    reminders: 'E-monity (InsERT i NEXOPS)',
    remindersHint: '{total} e-monitów, w tym {recent} w ostatnich 90 dniach',
    invoices: 'Otwarte faktury',
    events: 'Historia działań',
    cases: 'Sprawy w kancelarii',
    noReminders: 'InsERT nie wysłał e-monitów do tego klienta',
    noEvents: 'Brak wezwań i działań windykacyjnych w InsERT',
    notReached: 'nieosiągnięty',
    times: '{count}×',
    sent: 'Wysłano',
    invoice: 'Faktura',
    daysLate: 'Dni spóźnienia',
    due: 'Termin',
    remaining: 'Do zapłaty',
    lastReminder: 'Ostatni monit',
    remindersCount: 'Monity',
    letter: 'Wezwanie',
    action: 'Działanie',
    case: 'Sprawa',
    newCase: 'Przekaż do kancelarii',
    customerCard: 'Karta klienta',
  },
  cases: {
    title: 'Sprawy w kancelarii',
    hint: 'Sprawy przekazane do kancelarii, firmy windykacyjnej lub sądu — z InsERT i dodane ręcznie.',
    filter: { open: 'Otwarte', closed: 'Zamknięte', all: 'Wszystkie' },
    add: 'Nowa sprawa',
    empty: 'Brak spraw',
    customer: 'Klient',
    kind: 'Rodzaj',
    status: 'Stan',
    amount: 'Kwota przekazana',
    currentOverdue: 'Przeterminowane dziś',
    handedOverAt: 'Data przekazania',
    lawFirm: 'Kancelaria',
    notes: 'Notatki',
    source: 'Źródło',
    sourceErp: 'InsERT',
    sourceManual: 'NEXOPS',
    history: 'Historia',
    note: 'Dodaj notatkę',
    save: 'Zapisz',
    cancel: 'Anuluj',
    saved: 'Zapisano sprawę',
    customerPick: 'Dłużnik',
    customerPickHint: 'Wybierz dłużnika z listy należności',
    kinds: { AGENCY: 'Kancelaria / firma windykacyjna', COURT: 'Sąd' },
    statuses: {
      HANDED_OVER: 'Przekazana',
      IN_PROGRESS: 'W toku',
      IN_COURT: 'W sądzie',
      ENFORCEMENT: 'Egzekucja',
      SETTLED: 'Spłacona',
      CLOSED: 'Zamknięta',
      WRITTEN_OFF: 'Umorzona',
    },
    events: { CREATED: 'Założono', STATUS: 'Zmiana stanu', AMOUNT: 'Zmiana kwoty', LAW_FIRM: 'Zmiana kancelarii', NOTE: 'Notatka' },
  },
  factoring: {
    import: 'Import factoringu (CSV)',
    title: 'Factoring i COFACE — import CSV',
    hint: 'Format: numer_faktury;data_faktury;kwota;faktor;status (szczegóły: docs/COLLECTIONS-FACTORING-CSV.md).',
    file: 'Plik CSV',
    check: 'Sprawdź (próba na sucho)',
    apply: 'Zapisz {count} wierszy',
    summary: '{rows} wierszy: {valid} poprawnych, {invalid} z błędami',
    done: 'Zapisano: {created} nowych, {updated} zaktualizowanych',
    line: 'Wiersz {line}',
    list: 'Faktury sfinansowane',
    empty: 'Brak oznaczonych faktur',
    statuses: { FINANCED: 'sfinansowana', SETTLED: 'rozliczona', REJECTED: 'odrzucona' },
  },
  settings: {
    section: 'Windykacja — raport Top 40',
    sectionHint: 'Cykliczna wysyłka zestawienia 40 największych dłużników (XLS i PDF) e-mailem, np. do głównej księgowej.',
    enabled: 'Wysyłaj raport Top 40',
    recipients: 'Odbiorcy (adresy e-mail, po przecinku)',
    weekday: 'Dzień tygodnia',
    hour: 'Godzina',
    lastSent: 'Ostatnia wysyłka: {date}',
    neverSent: 'Raport nie był jeszcze wysyłany',
    save: 'Zapisz',
    saved: 'Zapisano ustawienia windykacji',
    weekdays: { '1': 'poniedziałek', '2': 'wtorek', '3': 'środa', '4': 'czwartek', '5': 'piątek', '6': 'sobota', '7': 'niedziela' },
  },
  error: 'Nie udało się wczytać danych windykacji',
};

export const collEn: typeof collPl = {
  nav: 'Debt collection',
  title: 'Debt collection',
  subtitle: 'Receivables, shame list, Top 40 and cases at law firms',
  subtitleAsOf: 'Receivables as of {date} · data from InsERT and NEXOPS',
  demo: 'sample data',
  tabs: { receivables: 'Receivables', shame: 'Shame list', top40: 'Top 40 to send', cases: 'Cases at law firms' },
  kpi: {
    open: 'Receivables',
    openHint: '{count} overdue invoices',
    overdue: 'Overdue',
    overdueHint: '{count} debtors',
    over90: 'Over 90 days',
    over90Hint: '{value} of overdue',
    top40: 'Top 40 total',
    top40Hint: '{value} of all overdue',
  },
  buckets: { all: 'All', d0_30: '0–30 days', d31_60: '31–60 days', d61_90: '61–90 days', d90plus: 'Over 90 days' },
  bucketsLabel: 'Days overdue',
  search: 'Search customer or tax ID…',
  region: 'Region',
  allRegions: 'All regions',
  noRegion: 'no region',
  noOwner: 'no account manager',
  groups: { byOwner: 'By sales rep', byRegion: 'By region', debtors: 'debtors', overdue: 'Overdue', over90: '> 90 days' },
  table: {
    customer: 'Customer',
    owner: 'Sales rep',
    open: 'Receivables',
    overdue: 'Overdue',
    days: 'Days',
    coefficient: 'Coefficient',
    stage: 'Stage',
    rank: 'No.',
    daysN: '{count} days',
    avgDays: 'avg {count} days',
    zeroTurnover: 'turnover 0',
    financed: 'factoring',
    turnover: '3-month turnover',
    oldestDue: 'Oldest due date',
    alerts: 'Alerts',
    share: 'Share',
    empty: 'No debtors for the selected filters',
    count: '{count} debtors',
    open90: 'Open the collection path',
  },
  stage: {
    NONE: 'No action',
    EMAIL: 'E-mail reminder',
    PHONE: 'Phone call',
    URGE1: 'Reminder 1',
    URGE2: 'Reminder 2',
    URGE3: 'Reminder 3',
    DEMAND: 'Payment demand',
    FINAL_DEMAND: 'Final demand',
    AGENCY: 'Law firm',
    COURT: 'Court',
    INTEREST_NOTE: 'Interest note',
    OTHER: 'Other action',
  },
  alert: {
    OVER_90: 'over 90 days',
    OVER_LIMIT: 'over credit limit',
    LEGAL: 'law firm / court',
    ZERO_TURNOVER: 'turnover 0',
    FINANCED: 'factoring',
    NO_ACTION: 'no action',
  },
  shame: {
    title: 'Shame list',
    hint: 'Coefficient = overdue × average days late / net turnover of the last 3 months (D14). Higher is worse.',
    zeroTitle: 'Turnover 0 — coefficient undefined',
    zeroHint: 'Debtors without sales in the last 3 months: the debt grows while the customer no longer buys.',
  },
  top40: {
    title: 'Top 40 debtors',
    hint: 'For the chief accountant — the 40 largest overdue balances with due date, amount and alerts.',
    share: '{value} of all overdue',
    avgDays: 'Avg days late',
    withLegal: 'At law firm / court',
    withoutAction: 'No action',
    over90: 'Over 90 days',
    sendNow: 'Send now',
    sent: 'Top 40 sent to {count} recipients',
    sendFailed: 'Failed to send: {count}',
    schedule: 'Recurring e-mail: {value}',
    scheduleOff: 'Recurring e-mail off (Settings → Debt collection)',
  },
  export: { xlsx: 'XLS', pdf: 'PDF', preparing: 'Preparing the file…', done: 'Downloaded {name}', failed: 'Could not prepare the file' },
  drawer: {
    path: 'Collection path',
    pathHint: 'Current episode — since the due date of the oldest overdue invoice',
    reminders: 'E-mail reminders (InsERT and NEXOPS)',
    remindersHint: '{total} e-mail reminders, {recent} in the last 90 days',
    invoices: 'Open invoices',
    events: 'Action history',
    cases: 'Cases at law firms',
    noReminders: 'InsERT has sent no e-mail reminders to this customer',
    noEvents: 'No demands or collection actions in InsERT',
    notReached: 'not reached',
    times: '{count}×',
    sent: 'Sent',
    invoice: 'Invoice',
    daysLate: 'Days late',
    due: 'Due',
    remaining: 'Outstanding',
    lastReminder: 'Last reminder',
    remindersCount: 'Reminders',
    letter: 'Demand',
    action: 'Action',
    case: 'Case',
    newCase: 'Hand over to a law firm',
    customerCard: 'Customer card',
  },
  cases: {
    title: 'Cases at law firms',
    hint: 'Cases handed to a law firm, collection agency or court — from InsERT and added by hand.',
    filter: { open: 'Open', closed: 'Closed', all: 'All' },
    add: 'New case',
    empty: 'No cases',
    customer: 'Customer',
    kind: 'Kind',
    status: 'Status',
    amount: 'Amount handed over',
    currentOverdue: 'Overdue today',
    handedOverAt: 'Handed over',
    lawFirm: 'Law firm',
    notes: 'Notes',
    source: 'Source',
    sourceErp: 'InsERT',
    sourceManual: 'NEXOPS',
    history: 'History',
    note: 'Add a note',
    save: 'Save',
    cancel: 'Cancel',
    saved: 'Case saved',
    customerPick: 'Debtor',
    customerPickHint: 'Pick a debtor from the receivables list',
    kinds: { AGENCY: 'Law firm / collection agency', COURT: 'Court' },
    statuses: {
      HANDED_OVER: 'Handed over',
      IN_PROGRESS: 'In progress',
      IN_COURT: 'In court',
      ENFORCEMENT: 'Enforcement',
      SETTLED: 'Paid',
      CLOSED: 'Closed',
      WRITTEN_OFF: 'Written off',
    },
    events: { CREATED: 'Created', STATUS: 'Status change', AMOUNT: 'Amount change', LAW_FIRM: 'Law firm change', NOTE: 'Note' },
  },
  factoring: {
    import: 'Factoring import (CSV)',
    title: 'Factoring and COFACE — CSV import',
    hint: 'Format: numer_faktury;data_faktury;kwota;faktor;status (details: docs/COLLECTIONS-FACTORING-CSV.md).',
    file: 'CSV file',
    check: 'Check (dry run)',
    apply: 'Save {count} rows',
    summary: '{rows} rows: {valid} valid, {invalid} with errors',
    done: 'Saved: {created} new, {updated} updated',
    line: 'Row {line}',
    list: 'Financed invoices',
    empty: 'No invoices marked',
    statuses: { FINANCED: 'financed', SETTLED: 'settled', REJECTED: 'rejected' },
  },
  settings: {
    section: 'Debt collection — Top 40 report',
    sectionHint: 'Recurring e-mail of the 40 largest debtors (XLS and PDF), e.g. to the chief accountant.',
    enabled: 'Send the Top 40 report',
    recipients: 'Recipients (e-mail addresses, comma separated)',
    weekday: 'Weekday',
    hour: 'Hour',
    lastSent: 'Last sent: {date}',
    neverSent: 'The report has not been sent yet',
    save: 'Save',
    saved: 'Debt collection settings saved',
    weekdays: { '1': 'Monday', '2': 'Tuesday', '3': 'Wednesday', '4': 'Thursday', '5': 'Friday', '6': 'Saturday', '7': 'Sunday' },
  },
  error: 'Could not load debt collection data',
};
